import React from 'react';
import { Typo } from 'components/Layout';
import { Icon } from 'components/Icon';

import styles from './styles.css';

const extractVideoId = (url) => {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  const match = url.match(regExp);
  if (match && match[7].length == 11) {
    return match[7];
  }
  console.error(`Bad video URL: ${url}`);
  return null;
};

const getEmbedUrl = (id) => `https://www.youtube.com/embed/${id}?enablejsapi=1`;

export default ({ url, width = 640, height = 360, title, hideModal }) => (
  <div className={styles.root}>
    <button className={styles.close} onClick={hideModal}>
      <Icon name="close" width={24} height={24} />
    </button>
    <Typo.Title size="medium" className={styles.title}>
      {title}
    </Typo.Title>
    <div className={styles.content}>
      <iframe
        id="tutorial-player"
        width={width}
        height={height}
        src={getEmbedUrl(extractVideoId(url))}
        frameBorder="0"
        allowFullScreen="allowfullscreen"
      ></iframe>
    </div>
  </div>
);
